import { render, staticRenderFns } from "./GuWeiAccount.vue?vue&type=template&id=03bc85a2&scoped=true"
import script from "./GuWeiAccount.vue?vue&type=script&lang=js"
export * from "./GuWeiAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bc85a2",
  null
  
)

export default component.exports